import { useEffect } from "react";
import { gsap } from "gsap";

// eslint-disable-next-line @typescript-eslint/no-empty-interface

export function useGsap(
  animation: () => void,
  deps?: React.DependencyList | undefined
) {
  useEffect(() => {
    const ctx = gsap.context(() => {
      animation();
    });

    return () => ctx.revert();
  }, deps);
}

export default useGsap;
